export default [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "homeModule" */ '@views/login'),
    meta: {
      isLogin: false,
      title : '登录'
    }
  }
]
